<template lang="pug">
  div.white(style="max-width:600px")
    v-layout.my-6(v-if="isFetching")
      v-row.fill-height.ma-0(align='center' justify='center')
        v-progress-circular.ma-auto(width="2" size="50" color="primary" indeterminate)
    .content-layout.mt-2(v-else)
      v-layout.my-6(v-if="bills.length == 0")
        v-row.fill-height.ma-0(align='center' justify='center')
          div.mx-auto
            v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
            p.caption No bills found or empty
      v-container.px-0.pt-0.white.lighten-4(v-else)
        template(v-for="(bill, index) in bills")
          bill-item.white.px-4(:bill.sync="bill" :index="index" :company="company")
          hr(v-if="index !== bills.length - 1" style="border: 3px solid var(--v-primary200);")
    div.mx-3.mt-4
      y-pagination.ma-4(v-model="page" :pageSize="pageSize" :count="count")
</template>

<script>
import BillItem from '@/components/BillItem.vue'

export default {
  name: 'Subscriptions',
  components: { BillItem },
  props: {
    company: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      isFetching: false,
      pageSize: 10,
      page: 1,
      count: 0,
      bills: []
    }
  },
  mounted() {
    if (!this.$route.query.page) {
      this.fetchBills(1)
    } else {
      this.fetchBills(this.$route.query.page)
    }
  },
  watch: {
    page(val) {
      this.$router.replace({ hash: this.$route.hash, query: { page: val } }).catch(() => {})
      if (!this.isFetching) {
        this.fetchBills(val)
      }
    }
  },
  methods: {
    fetchBills(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let url = `/subscription/bills/?page=${page}&page_size=${this.pageSize}&company=${this.company.id}`
      this.$axios
        .get(url)
        .then(response => {
          this.isFetching = false
          this.bills = response.data.results
          this.count = response.data.count
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  thead {
    background-color: red !important;
  }
  .bill-card {
    border: 0px;
    border-radius: 0;
    border-top: 4px solid var(--v-primary200);
  }
}
</style>